import React from 'react';

const Disclaimer = () => {
  return (
    <div className="pt-24 pb-20 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 legal-content">
      <h1>Legal Disclaimer</h1>
      <p className="text-sm border-l-2 border-accent-red pl-4 mb-8">
        Last Updated: March 2026
      </p>

      <div className="bg-card border border-border rounded-md p-6 mb-8">
        <p className="text-white font-medium mb-0">
          MediaVerse Labs strongly respects intellectual property rights and expects our users to do the same.
        </p>
      </div>

      <h2>No Content Hosting or Distribution</h2>
      <p>
        MediaVerse Labs and its applications (specifically TVVerse) <strong>do not host, store, archive, distribute, or broadcast any multimedia content.</strong>
      </p>
      <p>
        We do not maintain databases of streams, nor do we provide subscriptions to any content services. Our software is provided entirely empty of content.
      </p>

      <h2>Nature of the Software</h2>
      <p>
        TVVerse is a standalone, client-side media player application. It functions similarly to standard web browsers or generic media players (like VLC). Its sole purpose is to read text files (M3U format) provided by the user and render the media streams specified within those files.
      </p>

      <h2>User Responsibility</h2>
      <p>
        The user is entirely and solely responsible for the content they choose to load into the application.
      </p>
      <p>
        MediaVerse Labs has no control over, nor any visibility into, the playlists users load or the servers those playlists connect to. We cannot verify the licensing status of the content our users choose to play. If a user utilizes our software to access copyrighted material without authorization, the liability rests entirely with the user and the third-party entity hosting the stream.
      </p>

      <h2>Action Regarding Third-Party Services</h2>
      <p>
        Because we do not host or index any content, we cannot comply with takedown requests (such as DMCA notices) targeting specific media streams, as we have no servers to remove content from. Any such requests must be directed to the actual hosting provider of the stream in question.
      </p>
    </div>
  );
};

export default Disclaimer;